<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('TerminalsRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR PRZYŁĄCZY</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('attachmentsRegisterModal')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR ZAŁĄCZNIKÓW</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="show('variancesRegister')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR ROZBIEŻNOŚCI</span>
      </button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  components: {
    vueCustomScrollbar
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/registers/Registers.vue